<template>
  <div>
    <tk-flex  between >
      <public-header :title="pageData && pageData.headline" show-back></public-header>
    </tk-flex>
    <a-spin :spinning="loading" class="full-width" style="min-height: 60vh;" >
      <div style="display: none;">.</div>
      <div class="full-width bg-white border-radius-12" v-if="pageData && pageData.objectId" >
        <Layout :showMenu="true" :menuList="menuList" :defaultKeys="[0]" :activeKey.sync="key" :mainImage="false"  >
          <template slot="content" >
            <div v-show="key !== 1" class="font-14 font-bold m-b-20" style="color: #363B45" >{{ menuList[key].name }}</div>
            <div v-show="key === 0" style="height:100%">
              <a-row :gutter="[20,20]" class="font-12" style="color: #363B45" >
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  类型：{{ pageData.type === '0' ? '地区' : '全国' }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  v-if="pageData.type === '0'">
                  <a-tooltip>
                    <template slot="title">
                      {{agentList}}
                    </template>
                    代理商：代理商({{pageData.agent.length}})
                  </a-tooltip>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  订单数：{{ pageData.sales }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  是否开启：{{ pageData.isClose ? '否' : '是' }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  活动开始时间：{{ pageData.startDate | date }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  活动结束时间：{{ pageData.endDate | date }}
                </a-col>
              </a-row>
              <a-row :gutter="[20,20]" class="font-12" style="color: #363B45">
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  v-if="pageData.popupPicture">
                  <tk-flex>
                    弹出图片：
                    <viewer v-if="pageData.popupPicture" :images="[pageData.popupPicture]">
                      <img :src="pageData.popupPicture" style="width: 120px;height: 120px;border: 1px solid #E1E4EB;border-radius: 7px;object-fit: contain;" />
                    </viewer>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  v-if="pageData.detailPicture">
                  <tk-flex>
                    活动详情图：
                    <viewer v-if="pageData.detailPicture" :images="[pageData.detailPicture]">
                      <img :src="pageData.detailPicture" style="width: 120px;height: 120px;border: 1px solid #E1E4EB;border-radius: 7px;object-fit: contain;" />
                    </viewer>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"  >
                  <tk-flex>
                    <div class="unshrink">活动规则：</div>
                    <div v-html="pageData.details" class="p-15" style="height: 450px; width: 100%;overflow-y: scroll;border-radius: 6px;border: 1px solid #DBDDE1;" ></div>
                  </tk-flex>
                </a-col>
              </a-row>
            </div>
            <div v-if="key === 1" style="height:100%">
              <divvySetting :marketingCampaign="pageData"></divvySetting>
            </div>
            <div v-if="key === 2" style="height:100%" class="dividedVoucher">
              <ak-model-filter-card model="dividedVoucher" @search="search" @reset="reset" />
              <ak-model-card model="dividedVoucher" :filters="filters" :page.sync="page" tableSize="small" title="瓜分券明细" />
            </div>
          </template>
        </Layout>
      </div>
    </a-spin>

  </div>
</template>
<script>
import Layout from '../../components/layout.vue'
import publicHeader from '../../../components/publicHeader.vue'
import divvySetting from './divvySetting'

export default {
  components: {
    publicHeader,
    Layout,
    divvySetting
  },
  data () {
    return {
      loading: true, // 加载动画遮罩
      pageData: {},
      menuList: [
        {
          name: '基本信息'
        },
        {
          name: '瓜分设置'
        },
        {
          name: '瓜分券明细'
        }
      ],
      key: 0,
      id: null,
      filters: {},
      page: 1,
      agentList: ''
    }
  },
  // 监听页面id的变化
  watch: {
    $route (to, from) {
      this.init()
    },
    key (val) {
      if (val === 2) {
        this.filters = {
          marketingCampaign: this.id
        }
      }
    }
  },
  mounted () {
    this.id = this.$route.query.id
    this.init()
  },
  methods: {
    // 初始化菜单按钮
    async init () {
      try {
        this.filters.marketingCampaign = this.id
        await this.getData()
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    // 获取数据
    async getData () {
      const { data } = await this.$tkParse.get(`/classes/marketingCampaign/${this.$route.query.id}`, {
        params: { include: 'series,voltage,capacity,gift' }
      })
      console.log(data)
      data.details = data.details.replace(/<img/g, '<img style="max-width:100%;height:auto"')
      this.pageData = data
      if (data.type === '0') {
        let { data: user } = await this.$tkParse.get(`/classes/_User`, {
          params: {
            keys: 'nickName',
            limit: data.agent.length,
            where: {
              objectId: {
                $in: data.agent
              }
            }
          }
        })
        let arr = user.results.map(item => {
          return item.nickName
        })
        this.agentList = arr.join('、')
      }
    },
    search (filters) {
      // filters是组件自动生成的where搜索参数
      this.page = 1
      this.filters = { ...filters, marketingCampaign: this.id }
    },
    reset () {
      this.page = 1
      this.filters = {
        marketingCampaign: this.id
      }
    },
    // 刷新商品
    refresh () {
      this.getData()
    }
  }
}
</script>
<style lang="scss" scoped>
.dividedVoucher{
  ::v-deep{
    .model-filter{
      margin-bottom: 0 !important;
    }
    .model-card .ant-card-body{
      padding: 0 !important;
    }
  }
}
</style>
